import { NavigationState } from './types'

export const state: NavigationState = {
  menuItems: [
    {
      id: 1,
      text: 'Mi perfil',
      icon: 'account-outline',
      active: false,
      to: '/profile'
    },
    {
      id: 2,
      text: 'Agenda',
      icon: 'calendar-outline',
      active: true,
      to: '/schedule'
    },
    {
      id: 3,
      text: 'Pacientes',
      icon: 'account-multiple-outline',
      active: false,
      to: '/patients'
    },
    {
      id: 4,
      text: 'Administrativo',
      icon: 'folder-outline',
      active: false,
      to: '/admin'
    },
    {
      id: 5,
      text: 'Notificaciones',
      icon: 'bell-outline',
      active: false,
      to: '/notifications',
      alert: 0
    }
    /*
    {
      id: 2,
      text: 'Agenda',
      icon: 'view-dashboard-outline',
      active: true,
      to: '/'
    },
    {
      id: 4,
      text: 'Pacientes',
      icon: 'account-multiple-outline',
      active: false,
      to: '/patients'
    },
    {
      id: 7,
      text: 'Colaboración',
      icon: 'format-quote-open-outline',
      active: false,
      to: '/'
    },
    {
      id: 8,
      text: 'Ajustes',
      icon: 'cog-outline',
      active: false,
      to: '/'
    },
    {
      id: 9,
      text: 'Buscar',
      icon: 'magnify',
      active: false,
      to: '/'
    }*/
  ],
  activeItem: 1,
  expanded: false,
  hideSidebar: false,
  loadingPage: false,
  widthWindow: 0,
  deviceType: 1
}
